<template>
  <BRow>
    <BCol lg="12">
      <UserForm
        title="Ajouter un utilisateur"
        submitButtonText="Ajouter un utilisateur"
        mode="create"
        @user-submit="createUser"
        @cancel="handleCancel"
      />
    </BCol>
  </BRow>
</template>

<script>
import UserForm from '@/components/UserForm.vue';
import { userService } from '@/shared/services/user.service';
import notificationService from '@/shared/services/notification.service';

export default {
  name: 'CreateUser',

  components: {
    UserForm,
  },

  methods: {
    async createUser(formData) {
      console.log('CreateUser received form data:', formData);
      try {
        await userService.createUser(formData);
        notificationService.successAction('create', 'user');
        this.$router.push({ name: 'list-users' });
      } catch (error) {
        console.error('Error creating user:', error);
        const details =
          error.response?.data?.message ||
          "Erreur lors de la création de l'utilisateur.";
        notificationService.errorAction('create', 'user', details);
      }
    },

    handleCancel() {
      this.$router.push({ name: 'list-users' });
    },
  },
};
</script>
